import { useAppDispatch, useAppState } from '@/store';
import { useEffect, useMemo } from 'react';
import { getPhotoShootingPrice, selectPhotoShootingPrices, selectPricesIsLoading } from '../feature';

export const useGetPhotoShootingPrice = () => {
  const prices = useAppState(selectPhotoShootingPrices);
  const isLoading = useAppState(selectPricesIsLoading);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getPhotoShootingPrice());
  }, []);

  return useMemo(() => ({ prices, isLoading }), [prices, isLoading]);
};
